import React from 'react';
import './App.css';

const App: React.FC = () => {
  return (
    <div 
      className="app"
      style={{ backgroundColor: '#ce2a29' }}
    >
      <div className="container">
        {/* Logo */}
        <div className="logo-container">
          <img 
            src="./logo.png" 
            alt="KATS SAHNE Logo" 
            className="logo"
          />
        </div>

        {/* Content */}
        <div className="content">
          <h2 className="title">
            SİTEMİZ YAPIM AŞAMASINDADIR
          </h2>
          <p className="text">
            Bizi sosyal medya hesaplarımızdan takip edebilirsiniz
          </p>
          <p className="text">
            iletişim için{' '}
            <a 
              href="mailto:info@katssahne.com" 
              className="email-link"
            >
              info@katssahne.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default App;

